import { useProviderForm } from '@pages/Fabric/common/ProviderFormContext';
import { DatabricksAuthType, UnifiedDbxFormData } from '@pages/Fabric/types';
import { UseFormReturn } from 'react-hook-form';

import { AuthStateCard } from '../AuthCard';
import { ReadOnlyFabricView, ReadOnlySection } from '../ReadOnlyFabricView';
import { getAuthBadge, hasAuthStateCard } from '../utils';

const DBX_AUTH_LABELS: Record<string, string> = {
  [DatabricksAuthType.token]: 'Personal Access Token',
  [DatabricksAuthType.oauth]: 'OAuth',
  [DatabricksAuthType.entra]: 'Entra ID',
  [DatabricksAuthType.oidc]: 'OIDC'
};

export const DatabricksReadOnlyView = () => {
  const { formContext, fabricAuthState } = useProviderForm();
  const dbxFormContext = formContext as unknown as UseFormReturn<UnifiedDbxFormData>;
  const unifiedFabricData = dbxFormContext.watch('unifiedFabricData');

  if (!unifiedFabricData) {
    return null;
  }

  const isOAuth = unifiedFabricData.authType === DatabricksAuthType.oauth;
  const showAuthSection = isOAuth || hasAuthStateCard(fabricAuthState ?? null);

  const sections: ReadOnlySection[] = [
    {
      rows: [
        { label: 'Account URL', value: unifiedFabricData.databricksURL },
        {
          label: 'Auth Method',
          value: DBX_AUTH_LABELS[unifiedFabricData.authType] ?? unifiedFabricData.authType ?? '—'
        }
      ]
    },
    ...(showAuthSection
      ? [
          {
            title: 'Authentication',
            badge: fabricAuthState ? getAuthBadge(fabricAuthState) : undefined,
            content: <AuthStateCard authState={fabricAuthState ?? null} provider='Databricks' />
          }
        ]
      : []),
    {
      title: 'SQL Warehouse',
      badge: { label: 'Configured', variant: 'success' },
      rows: [
        { label: 'HTTP Path', value: unifiedFabricData.httpPath },
        { label: 'Catalog', value: unifiedFabricData.catalog },
        { label: 'Schema', value: unifiedFabricData.schema }
      ]
    }
  ];

  return <ReadOnlyFabricView sections={sections} />;
};
